import script from "./account_set.vue?vue&type=script&setup=true&lang=js"
export * from "./account_set.vue?vue&type=script&setup=true&lang=js"

import "./account_set.vue?vue&type=style&index=0&id=31534fe0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31534fe0"]])

export default __exports__